import React from 'react';
import styled from 'styled-components';
import { BREAKPOINT_SIZE, COLORS, MARGIN, Strong, SectionParagraph } from '../theme';

const MatchScoresRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const StyledThresholdLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 60px;
  margin-right: 1rem;
  margin-bottom: ${MARGIN.small};
  background: linear-gradient(to bottom, ${COLORS.white} 0%, ${COLORS.teal} 73%, ${COLORS.teal});

  @media (max-width: ${BREAKPOINT_SIZE.md}px) {
    margin-right: 0.5rem;
  }

  @media (max-width: ${BREAKPOINT_SIZE.sm}px) {
    width: 45px;
  }
`;

const ThresholdLabelText = styled.span`
  margin-top: 0;
  margin-bottom: 0;
  color: white;
  font-size: 16px;
  font-weight: bold;
`;

const MatchScore = () => (
  <>
    <SectionParagraph>
      A <Strong>match score</Strong> is generated for each pair, indicating how similar the two images are
    </SectionParagraph>
    <MatchScoresRow style={{ marginTop: MARGIN.small }}>
      {[...Array(9)].map((_, scoreIdx) => {
        return (
          <StyledThresholdLabel key={scoreIdx}>
            <ThresholdLabelText>0.{scoreIdx + 1}</ThresholdLabelText>
          </StyledThresholdLabel>
        );
      })}
    </MatchScoresRow>
  </>
);

export default MatchScore;
